import _classCallCheck from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/createClass";
import hasInterface from '../../../../hasInterface';
import IllegalArgumentException from '../../../../java/lang/IllegalArgumentException';
import CGAlgorithmsDD from './CGAlgorithmsDD';
import CoordinateSequence from '../geom/CoordinateSequence';
var Orientation = /*#__PURE__*/function () {
  function Orientation() {
    _classCallCheck(this, Orientation);
  }
  _createClass(Orientation, null, [{
    key: "index",
    value: function index(p1, p2, q) {
      return CGAlgorithmsDD.orientationIndex(p1, p2, q);
    }
  }, {
    key: "isCCW",
    value: function isCCW() {
      if (arguments[0] instanceof Array) {
        var ring = arguments[0];
        var nPts = ring.length - 1;
        if (nPts < 3) throw new IllegalArgumentException('Ring has fewer than 4 points, so orientation cannot be determined');
        var hiPt = ring[0];
        var hiIndex = 0;
        for (var i = 1; i <= nPts; i++) {
          var p = ring[i];
          if (p.y > hiPt.y) {
            hiPt = p;
            hiIndex = i;
          }
        }
        var iPrev = hiIndex;
        do {
          iPrev = iPrev - 1;
          if (iPrev < 0) iPrev = nPts;
        } while (ring[iPrev].equals2D(hiPt) && iPrev !== hiIndex);
        var iNext = hiIndex;
        do iNext = (iNext + 1) % nPts; while (ring[iNext].equals2D(hiPt) && iNext !== hiIndex);
        var prev = ring[iPrev];
        var next = ring[iNext];
        if (prev.equals2D(hiPt) || next.equals2D(hiPt) || prev.equals2D(next)) return false;
        var disc = Orientation.index(prev, hiPt, next);
        var isCCW = null;
        if (disc === 0) isCCW = prev.x > next.x;else isCCW = disc > 0;
        return isCCW;
      } else if (hasInterface(arguments[0], CoordinateSequence)) {
        var _ring = arguments[0];
        var _nPts = _ring.size() - 1;
        if (_nPts < 3) throw new IllegalArgumentException('Ring has fewer than 4 points, so orientation cannot be determined');
        var _hiPt = _ring.getCoordinate(0);
        var _hiIndex = 0;
        for (var _i = 1; _i <= _nPts; _i++) {
          var _p = _ring.getCoordinate(_i);
          if (_p.y > _hiPt.y) {
            _hiPt = _p;
            _hiIndex = _i;
          }
        }
        var _prev = null;
        var _iPrev = _hiIndex;
        do {
          _iPrev = _iPrev - 1;
          if (_iPrev < 0) _iPrev = _nPts;
          _prev = _ring.getCoordinate(_iPrev);
        } while (_prev.equals2D(_hiPt) && _iPrev !== _hiIndex);
        var _next = null;
        var _iNext = _hiIndex;
        do {
          _iNext = (_iNext + 1) % _nPts;
          _next = _ring.getCoordinate(_iNext);
        } while (_next.equals2D(_hiPt) && _iNext !== _hiIndex);
        if (_prev.equals2D(_hiPt) || _next.equals2D(_hiPt) || _prev.equals2D(_next)) return false;
        var _disc = Orientation.index(_prev, _hiPt, _next);
        var _isCCW = null;
        if (_disc === 0) _isCCW = _prev.x > _next.x;else _isCCW = _disc > 0;
        return _isCCW;
      }
    }
  }]);
  return Orientation;
}();
export { Orientation as default };
Orientation.CLOCKWISE = -1;
Orientation.RIGHT = Orientation.CLOCKWISE;
Orientation.COUNTERCLOCKWISE = 1;
Orientation.LEFT = Orientation.COUNTERCLOCKWISE;
Orientation.COLLINEAR = 0;
Orientation.STRAIGHT = Orientation.COLLINEAR;